import { useState } from "react";
import { Link } from "react-router-dom";
import { FaTachometerAlt, FaClipboardList, FaCog, FaSignOutAlt, FaChevronDown } from "react-icons/fa";

const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLeadsOpen, setIsLeadsOpen] = useState(false);

  return (
    <div
      className={`fixed left-0 top-16 h-[calc(100vh-64px)] bg-gray-800 text-white transition-all duration-300 ${isExpanded ? "w-64" : "w-16"
        } overflow-y-auto shadow-md border-r border-gray-600 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <div className="flex flex-col h-full p-2 ">
        <ul className="mt-6 space-y-4 flex-1">
          <SidebarItem to="/dashboard" icon={<FaTachometerAlt />} text="Dashboard" isExpanded={isExpanded} />

          {/* Leads Dropdown */}
          <li className="list-none">
            <button
              onClick={() => setIsLeadsOpen(!isLeadsOpen)}
              className="flex items-center justify-between w-full p-3 text-white hover:bg-gray-700 rounded-md"
            >
              <div className="flex items-center">
                <span className="text-lg"><FaClipboardList /></span>
                <span className={`ml-3 transition-all ${!isExpanded && "hidden"}`}>Leads</span>
              </div>
              {isExpanded && (
                <FaChevronDown className={`transition-transform ${isLeadsOpen ? "rotate-180" : "rotate-0"}`} />
              )}
            </button>
            {/* Dropdown Items */}
            {isLeadsOpen && (
              <ul className="mt-2 space-y-2 pl-6">
                <SidebarItem to="/leads" text="All Leads" isExpanded={isExpanded} />
                <SidebarItem to="/leads/home" text="Home page" isExpanded={isExpanded} />
                <SidebarItem to="/leads/contact" text="Contact Page" isExpanded={isExpanded} />
                <SidebarItem to="/leads/country" text="Country Pages" isExpanded={isExpanded} />
                <SidebarItem to="/leads/landing" text="Landing Pages" isExpanded={isExpanded} />
               </ul>
            )}
          </li>

          <SidebarItem to="/settings" icon={<FaCog />} text="Settings" isExpanded={isExpanded} />
        </ul>
        <div className="p-0">
          <SidebarItem to="/" icon={<FaSignOutAlt />} text="Logout" isExpanded={isExpanded} />
        </div>
      </div>
    </div>
  );
};

// Sidebar Item Component
const SidebarItem = ({ to, icon, text, isExpanded }) => (
  <li className="list-none">
    <Link to={to} className="flex items-center p-3 text-white hover:bg-gray-700 rounded-md">
      {icon && <span className="text-lg">{icon}</span>}
      <span className={`ml-3 transition-all ${!isExpanded && "hidden"}`}>{text}</span>
    </Link>
  </li>
);

export default Sidebar;
